import { UnknownAction } from "@reduxjs/toolkit";

import {
  SEEK_ANSWER_FOR_QUESTION_REQUEST,
  SEEK_ANSWER_FOR_QUESTION_SUCCEEDED,
  SEEK_ANSWER_FOR_QUESTION_FAILED,
  INVALIDATE_SEEK_SESSION,
  FETCHING_SEEKQA_SUGGESTIONS_FOR_ACCOUNT,
  FETCHING_SEEKQA_SUGGESTIONS_FOR_ACCOUNT_SUCCEEDED,
  FETCHING_SEEKQA_SUGGESTIONS_FOR_ACCOUNT_FAILED,
  INVALIDATE_SEEK_CHAT_ANIMATION,
  PROVIDE_FEEDBACK_FOR_CHAT,
  PROVIDING_FEEDBACK_FOR_CHAT_SUCCEEDED,
  SEEK_EVENT_FOR_QUESTION_SUCCEEDED
} from "../actions/actionTypes.jsx";

import _ from "lodash";
import { SeekAnswerErrorResponse, SeekAnswerRequest, SeekAnswerResponse, SeekChat, SeekChatState, SeekEventResponse } from "../../types/seek.js";

interface SeekState {
  session: string | null,
  chats: SeekChatState[],
}

const initialState: SeekState = {
  session: null,
  chats: []
};

export function seekReducer(state: SeekState = initialState, action: UnknownAction): SeekState {
  switch (action.type) {

    case SEEK_ANSWER_FOR_QUESTION_REQUEST: {
      const { uuid, session_id, dataset_id, question } = action.payload as SeekAnswerRequest;

      const currentSession = state.session;
      if (currentSession != null && currentSession != session_id) {
        return state;
      }

      const chat: SeekChatState = {
        uuid: uuid,
        querying: true,
        animate: true,
        error: null,
        item: {
          id: null,
          session_id: session_id,
          question: question,
          created_date: new Date().getTime(),
          modified_date: new Date().getTime(),
        },
        events: [],
      }

      const chats = [...state.chats, chat];

      return {
        ...state,
        chats: chats
      }
    }

    case SEEK_EVENT_FOR_QUESTION_SUCCEEDED: {
      const { uuid, session_id: eventSessionId, response } = action.payload as SeekEventResponse;

      const currentSession = state.session;
      if (currentSession != null && currentSession !== eventSessionId) {
        return state;
      }

      const chats = [...state.chats];
      const currentChat = chats.find((item) => item.uuid === uuid);
      if (!currentChat) return state;

      const updatedChats = chats.map((chat) =>
        chat.uuid === uuid
          ? { ...chat, events: [...(chat.events || []), response] }
          : chat
      );

      const sessionId = (response as { session_id?: string }).session_id ?? eventSessionId;
      return { ...state, session: sessionId, chats: updatedChats };
    }

    case SEEK_ANSWER_FOR_QUESTION_SUCCEEDED: {
      const { uuid, response } = action.payload as SeekAnswerResponse;

      const updatedChats = state.chats.map((chat) =>
        chat.uuid === uuid
          ? { ...chat, querying: false, item: response }
          : chat
      );
      return { ...state, session: response.session_id, chats: updatedChats };
    }

    case SEEK_ANSWER_FOR_QUESTION_FAILED: {
      const { uuid, session, error } = action.payload as SeekAnswerErrorResponse;

      const currentSession = state.session;
      if (currentSession != null && currentSession != session) {
        return state;
      }

      var chats = [...state.chats].map(chat => {
        if (chat.uuid === uuid) {
          return {
            ...chat,
            querying: false,
            error: error
          }
        }
        return chat;
      });


      return {
        ...state,
        chats: chats
      }
    }

    case INVALIDATE_SEEK_SESSION: {

      return {
        ...initialState
      }
    }

    case INVALIDATE_SEEK_CHAT_ANIMATION: {
      const uuid = action.payload as string;

      var chats = [...state.chats].map(chat => {
        if (chat.uuid === uuid) {
          return {
            ...chat,
            animate: false
          }
        }
        return chat;
      });

      return {
        ...state,
        chats: chats
      };
    }

    case PROVIDE_FEEDBACK_FOR_CHAT: {
      const { chat_id, helpful } = action.payload as any;
      const updatedChats = [...state.chats].map(chat => {
        if (chat.item.id === chat_id) {
          return {
            ...chat,
            item: {
              ...chat.item,
              isHelpful: helpful
            }
          }
        }
        return chat;
      });
      return { ...state, chats: updatedChats };
    }

    case PROVIDING_FEEDBACK_FOR_CHAT_SUCCEEDED: {
      const { chat_id, helpful } = action.payload as any;
      const updatedChats = [...state.chats].map(chat => {
        if (chat.item.id === chat_id) {
          return {
            ...chat,
            item: {
              ...chat.item,
              isHelpful: helpful
            }
          }
        }
        return chat;
      });
      return { ...state, chats: updatedChats };
    }

    default:
      return state;
  }
}